<script>
  import { onMount } from 'svelte';
  import { appStatus } from '../stores/ui.js';
  import { getVaultKey } from '../stores/vault.js';
  import { exchangeCodeForToken } from '../lib/youtube/oauth.js';

  let message = 'Processing OAuth response...';

  onMount(async () => {
    appStatus.set({
      primary: 'OAuth callback',
      secondary: 'Exchanging code for token locally'
    });

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const error = params.get('error');
    const state = params.get('state');
    const storedState = sessionStorage.getItem('ytcs:oauth-state');

    if (error) {
      message = `OAuth error: ${error}`;
      return;
    }

    if (!code) {
      message = 'Missing authorization code.';
      return;
    }

    if (state && storedState && state !== storedState) {
      message = 'State mismatch. Please restart OAuth.';
      return;
    }

    try {
      const vaultKey = getVaultKey();
      await exchangeCodeForToken({ code, vaultKey });
      sessionStorage.removeItem('ytcs:oauth-state');
      sessionStorage.removeItem('ytcs:pkce-verifier');
      message = 'OAuth complete. Token stored encrypted.';
      message = 'OAuth complete. Return to Scan from the sidebar.';
    } catch (err) {
      message = err.message || 'OAuth failed.';
    }
  });
</script>

<section class="panel">
  <h1>OAuth Callback</h1>
  <p>{message}</p>
  <p class="hint">If the vault is locked, unlock it in Settings and retry OAuth.</p>
</section>

<style>
  .panel {
    background: #fff;
    border-radius: 18px;
    padding: 2rem;
    border: 1px solid rgba(31, 41, 51, 0.08);
  }

  h1 {
    margin-top: 0;
  }

  .hint {
    color: var(--muted);
  }
</style>
